<template>
  <div>
    <details-modal
      :show="modals.role"
      :current-operation="currentOperation"
      @cancel="closeModal"
      @create="createRecord"
      @delete="deleteRecord"
      @update="updateRecord"
    >
      <form>
        <fg-input v-model="role.roleName" type="text" label="Nom" />
      </form>
      <p class="errorMessageInModal">{{ errorMessage }}</p>
    </details-modal>
    <div class="row">
      <div class="col-md-12">
        <crud-list
          ref="crudList"
          :fetch-data="fetchRoles"
          title="Rôles"
          @create="create"
          @row-clicked="rowClicked"
        >
          <el-table-column label="Nom" min-width="100">
            <div slot-scope="slotScope">{{ slotScope.row.roleName }}&nbsp;</div>
          </el-table-column>
        </crud-list>
      </div>
    </div>
  </div>
</template>

<script>
import DetailsModal from './Modals/DetailsModal.vue';
import CrudList from './CrudList.vue';

export default {
  components: {
    CrudList,
    DetailsModal,
  },
  data() {
    return {
      modals: {
        role: false,
      },
      currentOperation: {},
      role: {},
      errorMessage: ' ',
    };
  },
  methods: {
    rowClicked(row) {
      this.currentOperation = 'edit';
      this.role = { ...row };
      this.modals.role = true;
    },
    fetchRoles(pageNumber, pageSize, searchText) {
      let url = process.env.VUE_APP_ANNUAIRE_API_URL;
      if (searchText) {
        url += `/roleEntities/search/fulltext?sort=name&name=${searchText}&page=${pageNumber -
          1}&size=${pageSize}`;
      } else {
        url += `/roleEntities?sort=name&page=${pageNumber -
          1}&size=${pageSize}`;
      }
      return this.$http.get(url).then(response => ({
        records: response.data._embedded.roleEntities
          ? response.data._embedded.roleEntities
          : [],
        page: response.data.page,
      }));
    },
    deleteRecord() {
      this.$http
        .delete(
          `${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/roles/${this.role.roleId}`,
        )
        .then(response => {
          this.$refs.crudList.fetch();
          this.errorMessage = '';
          this.modals.role = false;
        })
        .catch(error => {
          this.errorMessage =
            'Une erreur est survenue, veuillez réessayer ou contacter le support.';
        });
    },
    updateRecord() {
      this.$http
        .patch(
          `${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/roles/${this.role.roleId}`,
          {
            roleName: this.role.roleName,
          },
        )
        .then(response => {
          this.$refs.crudList.fetch();
          this.errorMessage = '';
          this.modals.role = false;
        })
        .catch(error => {
          this.errorMessage =
            'Une erreur est survenue, veuillez réessayer ou contacter le support.';
        });
    },
    createRecord() {
      this.$http
        .post(`${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/roles/`, {
          roleName: this.role.roleName,
        })
        .then(response => {
          this.$refs.crudList.fetch();
          this.errorMessage = '';
          this.modals.role = false;
        })
        .catch(error => {
          this.errorMessage =
            'Une erreur est survenue, veuillez réessayer ou contacter le support.';
        });
    },
    create() {
      this.role = {};
      this.currentOperation = 'create';
      this.modals.role = true;
    },
    closeModal() {
      this.modals.role = false;
      this.errorMessage = '';
    },
  },
};
</script>

<style scoped></style>
